import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { verifyOtp } from '../../api/apiOtp';

/**
 * Hook for verifying OTP codes
 * Used for login, registration, and other verification purposes
 * @returns {Object} Mutation object with attempts remaining state
 */
export const useOtpVerify = () => {
    const [attemptsRemaining, setAttemptsRemaining] = useState(null);

    const mutation = useMutation({
        mutationFn: ({ channel, identifier, purpose, otp, cart_session_id }) => {
            return verifyOtp(channel, identifier, purpose, otp, cart_session_id);
        },
        onSuccess: (data) => {
            // Reset attempts on success
            setAttemptsRemaining(null);
        },
        onError: (error) => {
            // Track remaining attempts from error response
            if (error?.response?.status === 422) {
                const remaining = error.response.data?.meta?.attempts_remaining;
                if (remaining !== undefined) {
                    setAttemptsRemaining(remaining);
                }
            }
        }
    });

    return {
        ...mutation,
        attemptsRemaining,
        setAttemptsRemaining // Allow manual reset
    };
};
